import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Card, Form, Icon, Input, Button } from 'antd';
import PropTypes from 'prop-types';

const { Meta } = Card;

/**
 * @component
 * @category Search Page
 * @name ContactFormSet
 * @description This is the Contact Form component shown on top of all result cards
 * **Example**
 * ```js
 *   <ContactFormSet />
 * ```
 */
class ContactFormSet extends Component {
  state = {
    submitMsg: '', //for search contact form
    cardLoading: false,
  };

  /**
   * @description It is invoked when user submits contact form data
   * <br> <br>
   * **handleSubmit(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Form onsubmit event  |
   * <br> <br>
   * Returns: Type: void
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        //show loading
        this.setState({ cardLoading: true });
        //submit contact form data to server
        //values {name: "name", email:"email"}
        this.props.submitSearchContactForm(values, (data) =>
          this.setState({ submitMsg: data, cardLoading: false })
        );
      }
    });
  };
  render() {
    const { submitMsg, cardLoading } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      searchContactFormHeader,
      searchContactFormSubHeader,
      // primaryColor,
      secondaryColor,
    } = this.props;
    return (
      <>
        <Card
          loading={cardLoading}
          title={
            submitMsg ? (
              <Button
                type="danger"
                onClick={this.props.closeSearchContactForm}
                style={{
                  border: 'none',
                  color: '#fff',
                  background: secondaryColor,
                  borderBottom: `2px solid rgba(128,128,128,0.9)`,
                  fontSize: '16px',
                  borderRadius: '5px',
                }}
              >
                Close
              </Button>
            ) : (
              <div style={{ whiteSpace: 'pre-wrap' }}>
                <h1
                  style={{
                    color: 'black',
                  }}
                >
                  {searchContactFormHeader}
                </h1>
                <span
                  style={{
                    fontSize: '12px',
                  }}
                >
                  {searchContactFormSubHeader}
                </span>
              </div>
            )
          }
          style={{
            borderRadius: '5px',
            boxShadow: '0 1px 5px rgba(0, 0, 0, 0.15)',
            background: 'white',
            height: 'auto',
            margin: '0px 0px 15px 0px',
          }}
        >
          {/* hide form elements upon success submit message */}
          {!submitMsg && (
            <Form onSubmit={this.handleSubmit} className="testR1">
              <Form.Item>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Input your name!' }],
                })(
                  <Input
                    prefix={
                      <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="Name"
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('email', {
                  rules: [{ required: true, message: 'Input your Email!' }],
                })(
                  <Input
                    prefix={
                      <Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="email"
                    placeholder="Email"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    border: 'none',
                    color: '#fff',
                    background: secondaryColor,
                    borderBottom: `2px solid rgba(128,128,128,0.9)`,
                    fontSize: '16px',
                    borderRadius: '5px',
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
          {/* show submit message upon success post request */}
          {submitMsg && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Icon
                type="check-circle"
                theme="twoTone"
                twoToneColor="#52c41a"
                style={{
                  fontSize: '28px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
                className="testR1"
              />
              <h2
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                className="testR1"
              >
                {submitMsg}
              </h2>
            </div>
          )}
        </Card>
      </>
    );
  }
}

const ContactForm = Form.create({ name: 'search_contact_form' })(
  ContactFormSet
);

ContactFormSet.propTypes = {
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
  /**
   * whether to show contact form
   */
  showSearchContactForm: PropTypes.bool,

  /**
   * Header text for Contact form above all result cards on search page.
   */
  searchContactFormHeader: PropTypes.string,
  /**
   * Sub Header text description for Contact form above all result cards on search page.
   */
  searchContactFormSubHeader: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    // primaryColor: state.code_config.primaryColor,
    secondaryColor: state.code_config.secondaryColor,
    showSearchContactForm: state.route.showSearchContactForm,

    searchContactFormHeader: state.code_config.searchContactFormHeader,
    searchContactFormSubHeader: state.code_config.searchContactFormSubHeader,
  };
};

export default connect(mapStateToProps, actions)(ContactForm);
